import { z } from 'zod';
import { cursorPageSchema, decimalStringSchema, isoDateTimeSchema, uuidSchema } from './common.js';
/** Half stars allowed: 0.5 .. 5.0 */
export const starsSchema = z
    .number()
    .min(0.5)
    .max(5)
    .refine((v) => Number.isInteger(v * 2), 'Only whole or half stars are allowed');
export const ratingSchema = z.object({
    recipeId: uuidSchema,
    stars: starsSchema.nullable(),
    note: z.string().nullable(),
    updatedAt: isoDateTimeSchema.nullable(),
});
export const setRatingRequestSchema = z.object({
    stars: starsSchema.nullable(),
    note: z.string().max(1000).nullable().optional(),
});
export const cookingLogEntrySchema = z.object({
    id: uuidSchema,
    recipeId: uuidSchema,
    recipeTitle: z.string(),
    cookedAt: isoDateTimeSchema,
    servings: decimalStringSchema.nullable(),
    rating: starsSchema.nullable(),
    notes: z.string().nullable(),
    photoAssetId: uuidSchema.nullable(),
    photoUrl: z.string().nullable(),
    createdAt: isoDateTimeSchema,
});
export const cookingLogWriteSchema = z.object({
    cookedAt: isoDateTimeSchema.optional(),
    servings: decimalStringSchema.nullable().optional(),
    rating: starsSchema.nullable().optional(),
    notes: z.string().max(5000).nullable().optional(),
    photoAssetId: uuidSchema.nullable().optional(),
    /** Also update the private recipe rating with this value. */
    updateRecipeRating: z.boolean().default(false),
});
export const cookingLogPageSchema = cursorPageSchema(cookingLogEntrySchema);
//# sourceMappingURL=ratings.js.map